var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.552 6l4.334-4.333a.39.39 0 10-.553-.553L6 5.448 1.667 1.114a.39.39 0 00-.553.553L5.447 6l-4.333 4.333a.39.39 0 00.553.553L6 6.553l4.333 4.333a.389.389 0 00.553 0 .39.39 0 000-.553L6.552 6z",
    stroke: "#000",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.21eca65d53095479d127c61cb36ffdb1.svg";
export { ForwardRef as ReactComponent };